import React from 'react'
import { FormImgBox, FormRemoteStyle, FormGamesfiStyle } from './FormsStyled'
import { ReactComponent as GamesFi } from 'assets/Hero/GAMESFI.svg'

const FormImage: React.FC = () => {

    return (
        <>
            <FormImgBox>
                <FormRemoteStyle>
                    <FormGamesfiStyle>
                        <GamesFi />
                    </FormGamesfiStyle>
                </FormRemoteStyle>
            </FormImgBox>
        </>
    )
}

export default FormImage